import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogListPageRoutingModule } from './blog-list-routing.module';
import { BlogListPage } from './blog-list.component';
import { RouterModule } from '@angular/router';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { PlaceholderTableComponent } from '@components/placeholders/table/table.component';
import { HeaderPageTitleBoxComponent } from '@components/headers/page-title-box/page-title-box.component';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { ShowForPermissionsDirective } from '@directives/show-for-permissions.directive';

@NgModule({
  declarations: [
    BlogListPage
  ],
  imports: [
    CommonModule,
    BlogListPageRoutingModule,
    RouterModule,
    BackboneComponent,
    PlaceholderTableComponent,
    HeaderPageTitleBoxComponent,
    ButtonModule,
    ChipModule,
    ShowForPermissionsDirective
  ]
})
export class BlogListPageModule { }
